import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/apiClient";

export default function BuildInfo() {
  const { data: buildInfo } = useQuery({
    queryKey: ["buildInfo"],
    queryFn: () => apiClient.get("/api/build-info"),
    staleTime: Infinity, // Build info won't change during session
    retry: false,
  });

  if (!buildInfo || buildInfo.buildNumber === "dev") {
    return null;
  }

  return (
    <div className="fixed bottom-2 right-2 text-xs text-slate-400 opacity-50 hover:opacity-100 transition-opacity">
      Build #{buildInfo.buildNumber}
    </div>
  );
}
